import { getData } from '../../../utils/http';
import { JSONAPI_URLS, URLS } from '../../../consts/endpoints';
import { isDefined } from '../../../utils/isDefined';
import Optional from '../../../utils/optional';
import urlCreator from '../../../utils/urlCreator';
import checkIfIsEsimCard from '../../../utils/checkIfIsEsimCard';
import checkIfIsIoT from '../../../utils/checkIfIsIoT';
import findIccFromSub from '../../../utils/findIccFromSub';

const QUERY_PARAMS = {
  include: 'primary_card'
};

const getSimcard = async ({ id, number, subscription }) => {
  let simcard = {};
  let activationCode = void 0;
  let isESimCard = false;
  let isIoTCard = false;

  try {
    if (isDefined(number)) {
      const { data } = await getData(
        urlCreator(JSONAPI_URLS.SIM_CARDS, {
          ...QUERY_PARAMS,
          filter: { msisdn: number }
        })
      );
      if (isDefined(data[0])) {
        simcard = data[0];
      }
    } else {
      const { data } = await getData(
        urlCreator(`${URLS.SIM_CARDS}/${id}.json`, QUERY_PARAMS)
      );

      simcard = data;
    }

    const icc = findIccFromSub(
      subscription,
      Optional(number).or(simcard?.msisdn)
    );

    if (isDefined(icc) && isDefined(simcard?.client_id)) {
      try {
        const response = await getData(
          `${URLS.QUOTE_CLIENTS}/${simcard.client_id}/resources/search?icc=${[
            icc
          ]}`
        );
        activationCode = Optional(response?.activationCode).or(void 0);
        isESimCard = checkIfIsEsimCard(response?.simCardType);
        isIoTCard = checkIfIsIoT(response?.usage_type);
        simcard = {
          ...simcard,
          icc: response.icc,
          puk1: response.puk1,
          pin1: response.pin1
        };
      } catch {
        return void 0;
      }
    }
  } finally {
    return { simcard, activationCode, isESimCard, isIoTCard };
  }
};

export default getSimcard;
